const receiverTypesModel = vm => ({
  title: vm.$gettext('Receiver Types'),
  endpoint: 'receiver-types',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: false,
      editable: true
    },
    {
      key: 'order',
      label: vm.$gettext('Order'),
      sortable: true,
      editable: true
    }
  ],
  filters: ['id', 'name', 'description']
})

export default receiverTypesModel
